import {configureStore} from '@reduxjs/toolkit';
import inquiry from '@/lib/reduxToolkit/inquiry';

export const store = configureStore({
  reducer: {
    inquiry
  },
})
